import {Box, Button} from '@mui/material';
import React, {useState} from 'react';
import FragmentSubmitTab1 from 'view/mypage/FragmentSubmitTaskTab1';
import FragmentSubmitTab2 from 'view/mypage/FragmentSubmitTaskTab2';

export const FragmentView = props => {
  const [tabStatus, setTabStatus] = useState(1);

  function showTab() {
    switch (tabStatus) {
      case 1:
        return <FragmentSubmitTab1 />;
      case 2:
        return <FragmentSubmitTab2 />;

      default:
        return <FragmentSubmitTab1 />;
    }
  }
  return (
    <Box style={{width: '100%', maxWidth: '120rem'}}>
      <Box style={{fontWeight: 'bold', fontSize: '1.375rem'}}>제출한 과제</Box>
      <Box
        style={{
          backgroundColor: '#E6E8EB',
          width: '100%',
          height: '2px',
          marginTop: '1.3rem',
          marginBottom: '1.75rem',
        }}
      />
      <Box
        style={{color: '#87929D', fontSize: '0.875rem', marginBottom: '0.5rem'}}
      >
        기간별 과제 제출 결과와 수정 과정을 확인하세요.
      </Box>
      <Box style={{display: 'flex'}}>
        <Button
          style={{
            color: tabStatus == 1 ? 'black' : '#ADB4BA',
            borderBottom:
              tabStatus == 1 ? '1px solid black' : '1px solid #F4F6F6',
            borderRadius: 0,
            padding: '0.5rem 2rem',
            whiteSpace: 'nowrap',
          }}
          onClick={() => {
            setTabStatus(1);
          }}
        >
          기간별 제출 기록
        </Button>

        <Button
          style={{
            color: tabStatus == 2 ? 'black' : '#ADB4BA',
            borderBottom:
              tabStatus == 2 ? '1px solid black' : '1px solid #F4F6F6',
            borderRadius: 0,
            padding: '0.5rem 2rem',
            whiteSpace: 'nowrap',
          }}
          onClick={() => {
            setTabStatus(2);
          }}
        >
          과제별 저장한 글
        </Button>
      </Box>
      {showTab()}
    </Box>
  );
};
export default FragmentView;
